import axios from 'axios'
import { EXCLUIR_USUARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirUsuario (idUsuario, idEmpresa) {
  const url = `${URL}/usuarios/${idUsuario}/empresa/${idEmpresa}/excluir`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_USUARIO,
        payload: response

      })
  );
}
